import script from "./MergeOrdersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MergeOrdersDialog.vue?vue&type=script&setup=true&lang=js"

import "./MergeOrdersDialog.vue?vue&type=style&index=0&id=7db92352&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db92352"]])

export default __exports__